import { render, staticRenderFns } from "./LearningForm.vue?vue&type=template&id=584ea815&"
import script from "./LearningForm.vue?vue&type=script&lang=js&"
export * from "./LearningForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports